<template>
  <div id="app">
    <router-view/>
    <transition name="fade">
      <div class="backToTop"
           v-show="!cloakShow"
           @click="backToTop"
           @mouseleave="changeBg"
           @mouseenter="changeBg"
           ref="toTop"
      >
        <img src="./assets/回到顶部.png" alt="">
      </div>
    </transition>
  </div>
</template>


<script>
  import {isPC} from './utils/methods'
  export default{
    data(){
      return {
         name:'App',
          bs:{},
        cloakShow:false
      }
    },
    methods:{
      changeBg(e){
        this.$refs.toTop.style.backgroundColor = e.type === 'mouseenter' ? '#97D9E1' : 'white';
      },
      backToTop(){
        if(isPC()){
          document.querySelector('#app').scrollTop = 0
        }else{
          this.bs.scrollTo(this.bs.x,0,1000)
        }
      }
    }
  }
</script>

<style lang="scss">
  .fade-enter-active{
    transition: all .3s ease-in-out;
  }
  .fade-leave-active {
    transition: all 0s !important;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0 !important;
  }
  *{
    margin: 0;
    img{
      pointer-events: none;
    }
  }
  body{
    background-color: white;
    margin: 0;
    padding: 0;
    width: 100%;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar{
      display: none;
    }
  }
  #app{
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar{
      display: none;
    }
    .backToTop{
      position: fixed;
      right: 6vw;
      top: 76vh;
      width: 3.5vw;
      height: 3.5vw;
      border-radius: 10px;
      transition: .3s all ease-in-out;
      img{
        width: 3.5vw;
        height: 3.5vw;
      }
    }
    @media(max-width: 576px) {
      .backToTop{
        width: 12vw ;
        height: 12vw;
        right: 10vw;
        top: 80vh;
        border-radius: 10px;
        img{
          width: 12vw;
          height: 12vw;
        }
      }
    }
  }

</style>
